

/**
 * Toast manager instance
 */
let toastManager;

export const initialize = (instance) => {
    toastManager = instance;
};

export const toastInfo = (content,options,callback) => {

    return toast(content,{
        ...options,
        appearance: 'info'
    },callback);

};

export const toastSuccess = (content,options,callback) => {

    return toast(content,{
        ...options,
        appearance: 'success'
    },callback);

};


export const toastWarning = (content,options,callback) => {

    return toast(content,{
        ...options,
        appearance: 'warning'
    },callback);

};

export const toastError = (content,options,callback) => {

    return toast(content,{
        ...options,
        appearance: 'error'
    },callback);

};

export const removeToast = (id,callback) => {
    toastManager.removeToast(id,callback);
};

export const toast = (content,options,callback) => {
    toastManager.addToast(content,options,callback);
};



// WEBPACK FOOTER //
// ./src/react-notifications.js